import { Trans } from "@lingui/macro";
import React, { useEffect, useRef, useState } from "react";
import { InputText } from "components/UI/InputText/InputText";
import { useInputChange } from "hooks/useInputChange";
import { Button } from "components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  dOrdersAddProductToCartAC,
  dOrdersSetDetailProductAC,
} from "model/dashboardOrders/dOrdersActionCreators";
import { IdOrdersState } from "model/dashboardOrders/dOrdersReducer";
import { Alert } from "components/UI/Alert/Alert";

// Type
export type typePopupChangePrice = {
  setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

const templateMarkLabel1 = /^01.{14}21.+(91|92|93)/;
const templateMarkLabel2 = /^01.{14}21.+/;
// Component
export const PopupEnterMark: React.FC<typePopupChangePrice> = ({
  setOpenPopup,
}) => {
  const dispatch = useDispatch();
  const refInput = useRef<any>(null);

  const product = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.detailProduct,
  );
  const { value: labelValue, changeValueHandler: labelValueHandler } =
    useInputChange("");

  // const onApplyClickHandler = () => {
  //   if (productIndex && typeof productIndex === 'string') dispatch(dOrdersSetMarkLabelForProductInCartItemAC(Number(productIndex),labelValue.trim()))
  //     setOpenPopup(false)
  // }

  useEffect(() => {
    if (refInput?.current) {
      refInput?.current?.focus();
    }
  }, []);

  //did unmount
  useEffect(() => {
    return () => {
      dispatch(dOrdersSetDetailProductAC(undefined));
    };
  }, [dispatch]);

  // const product = useSelector((state: {  dOrders: IdOrdersState }) => state.dOrders.detailProduct)
  const currentOrder = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.newOrder,
  );
  const selectedStore = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.selectedStore,
  );

  //validate
  const [validationObject, setValidationObject] = useState({
    validMarkLabel: true,
    requiredMarkedLabel: true,
    isExistMarkLabel: false,
  });
  useEffect(() => {
    if (labelValue.trim()) {
      setValidationObject(() => {
        return {
          isExistMarkLabel: false,
          requiredMarkedLabel: true,
          validMarkLabel: true,
        };
      });
    } else {
      setValidationObject(() => {
        return {
          isExistMarkLabel: false,
          validMarkLabel: true,
          requiredMarkedLabel: false,
        };
      });
    }
  }, [labelValue]);

  //validate match barcode and label
  //barcode in markLabel should be length===14, if less  add 0 in start string
  const checkBarcodeLength = (barcode: string) => {
    return barcode.length < 14
      ? barcode.padStart(14, "0")
      : barcode.length > 14
        ? null
        : barcode;
  };
  //check all barcodes in product
  const validationBarcodeHelper = (barcodes: string[], label: string) => {
    return barcodes.some((barcode) => label === checkBarcodeLength(barcode));
  };

  const validationMarkLabelHelper = (markLabel: string, barcodes: string[]) => {
    const temp1 = markLabel.match(templateMarkLabel1);
    const temp2 = markLabel.match(templateMarkLabel2);

    let resLabel: string | null;

    if (temp1) {
      resLabel = validationBarcodeHelper(barcodes, temp1[0].substring(2, 16))
        ? temp1[0].substring(0, temp1[0].length - 2)
        : null;
    } else if (temp2) {
      resLabel = validationBarcodeHelper(barcodes, temp2[0].substring(2, 16))
        ? temp2[0]
        : null;
    } else {
      resLabel = validationBarcodeHelper(
        barcodes,
        markLabel.trim().substring(0, 14),
      )
        ? markLabel
        : null;
    }

    return resLabel
      ? resLabel.length >= 63
        ? resLabel.substring(0, 63)
        : resLabel
      : null;
  };

  const onApplyClickHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (typeof product === "object") {
      const isValidMarkLabel = validationMarkLabelHelper(
        labelValue.trim(),
        product!.barcodes,
      );
      setValidationObject((v) => {
        return { ...v, validMarkLabel: !!isValidMarkLabel };
      });

      if (product && isValidMarkLabel) {
        const sameProductList = currentOrder!.productList.filter(
          (item) => item.product.id === product.id,
        );

        let isRepeatMarkLabel = false;

        sameProductList.some((item) => {
          if (item.labels) {
            item.labels.includes(isValidMarkLabel)
              ? (isRepeatMarkLabel = true)
              : // eslint-disable-next-line
                (isRepeatMarkLabel = isRepeatMarkLabel);
          }

          return null;
        });

        if (isRepeatMarkLabel) {
          setValidationObject((v) => {
            return { ...v, isExistMarkLabel: true };
          });
          return;
        }

        const storeWithPrice = product.stores.find(
          (item) => item.store.id === selectedStore!.id,
        );

        dispatch(
          dOrdersAddProductToCartAC(
            product,
            storeWithPrice!.price,
            isValidMarkLabel,
          ),
        );
        setOpenPopup(false);
      }
    }
  };

  return (
    <div className="flex flex-col gap-2 sm:gap-4">
      {product &&
      // @ts-ignore
      product.barcodes.length ? (
        <>
          <form
            onSubmit={(event) => onApplyClickHandler(event)}
            className="flex flex-col gap-4"
          >
            <div>
              <InputText
                id="markLabel"
                label={<Trans>Mark label</Trans>}
                type="text"
                value={labelValue}
                onChange={labelValueHandler}
                required={true}
                errorMessage={
                  validationObject.requiredMarkedLabel ? (
                    validationObject.validMarkLabel ? undefined : (
                      <Trans>Marking don't matched any barcode!</Trans>
                    )
                  ) : (
                    <Trans>Required field</Trans>
                  )
                }
                autoFocus={true}
                inputRef={refInput}
              />
            </div>
            {validationObject.isExistMarkLabel && (
              <div
                className={"text-xs text-center whitespace-wrap text-red-500"}
              >
                <Trans>This marking already exist in product list.</Trans>
              </div>
            )}
            <div
              className={"text-xs text-center whitespace-wrap text-gray-500"}
            >
              <Trans>
                Each marked product has a unique label.
                <br /> Without a label, you will not be able to add the item to
                your shopping cart.
              </Trans>
            </div>
            <Button
              type="submit"
              label={<Trans>Apply</Trans>}
              disabled={
                !validationObject.validMarkLabel ||
                !validationObject.requiredMarkedLabel ||
                validationObject.isExistMarkLabel
              }
            />
          </form>
        </>
      ) : (
        <div>
          <Alert
            type={"info"}
            title={
              <Trans>
                This product has no barcodes. Marking check not possible
              </Trans>
            }
          />
        </div>
      )}
    </div>
  );
};
